import { MoreHoriz } from "@mui/icons-material";
import { Box, IconButton, Popover, Stack } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DeleteMessage from "./DeleteMessage";

export default function MessageMenu({ messageId }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Stack direction={"row"} justifyContent={"right"}>
      <IconButton
        size="small"
        onClick={handleOpen}
        title={t("OpenMenu")}
        sx={{ p: 0.5, color: "white" }}
      >
        <MoreHoriz fontSize="small" />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box p={1}>
          <DeleteMessage msgId={messageId} handleClose={() => handleClose()} />
        </Box>
      </Popover>
    </Stack>
  );
}
